<template>
  <v-textarea
    auto-grow
    counter
    :disabled="field.readonly"
    :error-messages="errors"
    :hide-details="dense"
    :model-value="modelValue"
    :multiple="field.multiple"
    rows="3"
    :rules="rules"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #label>
      <FieldLabel :field="field" />
    </template>
  </v-textarea>
</template>

<script setup lang="ts">
defineProps<{
  field: FieldConfig
  modelValue: string | string[] | undefined
  errors?: string[]
  dense?: boolean
  rules?: FormRule[]
}>();
defineEmits(['update:modelValue']);
</script>
